import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'

import { useAuth } from './use-auth'

import { SpaceType } from 'app/types'
import { uniqueArray } from 'modules'

const sortByName = (spaces: Array<SpaceType>) =>
    uniqueArray<SpaceType, SpaceType>(
        spaces
            .filter(Boolean)
            .sort((a, b) => (a?.name?.toLowerCase() > b?.name?.toLowerCase() ? 1 : -1))
    )

export const useMySpaces = () => {
    const { uid } = useAuth()

    useFirestoreConnect({
        collection: uid ? 'spaces' : 'empty',
        where: [uid ? `members.${uid}.uid` : 'empty', '==', uid],
        storeAs: 'mySpaces'
    })

    const mySpaces = useSelector(state => state.firestore?.data.mySpaces)

    return useMemo(
        () => ({
            isMySpacesLoading: !isLoaded(mySpaces),
            mySpaces: sortByName(Object.values(mySpaces || {}))
        }),
        [mySpaces]
    )
}
